import index from './en/index'
import opportunity from './en/opportunity'
import chat from './en/chat'
import employee from './en/employee'
import collection from './en/collection'
import potentialOrder from './en/potentialOrder'
import hotspot from './en/hotspot'

export default {
  ...opportunity,
  ...chat,
  ...employee,
  ...collection,
  ...potentialOrder,
  ...hotspot,
  rLogin: {
    'systemTip': 'System tip',
    'loginExpired': 'The recording status has expired. Please log in again',
    'cancel': 'cancel',
    'loginAgain': 'login again'
  },
  language: {
    name: 'en'
  },
  ...index,
  tip: {
    success: 'Success',
    loading: 'Loading...'
  },
  live: {
    status: {
      '0': 'On live',
      '1': 'Upcoming',
      '2': 'Replay'
    },
    startTime: 'Start time',
    looker: 'Playback',
    toLive: 'Enter'
  },
  like: 'Like',
  exhibitorInfo: 'Details of the exhibitor',
  follow: 'View',
  joinExhibitorNum: 'Number of attendance',
  registeredCapital: 'Registered capital',
  scaleOfCompany: 'Scale of company',
  collect: ['Collect', 'Followed'],
  message: 'Message',
  'Send message': 'Send message',
  invite: 'Invitation',
  details: 'Detail',
  placeholder: 'Please enter your',
  pageView: 'Views',
  collection: 'Followed',
  editor: 'Edit',
  companyEditor: 'Edit company information',
  del: 'Delete',
  selectType: 'Select type',
  auditStatus: ['Passed', 'Pending', 'Failed to pass'],
  upgradeBrowser: 'Please upgrade the browser...',

  // Header translation
  logout: 'Logout',
  profile: 'Personal',
  notification: 'Message',
  myFavorite: 'My favorites',
  watchHistory: 'View history',
  customService: 'Customer service',
  serviceTel: 'Tel:',
  invitation: 'Invitation',
  marketing: 'Marketing',
  moreFeature: 'More features',
  invitationManagement: "Contacts",
  baseMess: 'Basic information',
  companyManage: 'Company',
  companybaseMessManage: 'Personal information',
  exhibitsManage: 'Product management',
  actor: 'Guest',
  exhibitors: 'Exhibitors',
  exhibits: 'Products',
  business: 'Business',
  find: 'Find',
  home: 'Home',
  baoiHome: 'CAC',
  qatitle: 'Q&A',
  disclaimer: 'Disclaimer',
  img: 'Image',
  video: 'Video',
  address: 'Address',
  tel: 'Tel',
  email: 'Email',
  www: 'Website',
  registerLogin: 'Register/Login',
  // passLogin: 'Use password',
  // codeLogin: 'Use verification code',
  passLogin: 'By Email',
  codeLogin: 'By Mobile',
  ydjTip:'Registration is not yet open, so stay tuned!',
  getCode: 'Get verification code',
  login: 'Login',
  loginRegister: "Login / Register",
  'You sign up and agree': 'I sign up and agree with',
  'Privacy agreement': '《Privacy agreement》',
  register: 'New Registration',
  code: 'Verification Code',
  password: 'Password',
  phone: 'Mobile No',
  resetPassword: 'Set Password',
  newPassword: 'New password',
  inputAgain: 'Confirm Password',
  newPasswordAgain: 'Please type the password again',
  'Please enter your code': 'Please enter your code',
  confirm: 'Confirm',
  confirmPassword: 'Confirm Password',
  forgetPassword: 'Forgot password?',
  exhibitorCode: 'Exhibitor code',
  backLogin: 'Back to login',
  bindExhibitor: 'Bind exhibitor',
  setPassPageTip: [
    'We have sent you a verification code to confirm your email, please log in to your mailbox to check the verification code to complete your password setting.',
    'After setting the login password, you can use the password to log in'
  ],
  myIndentity: ['我是展商', 'I am exhibitor', '我是客商', 'I am Guest'],
  save: 'Save',
  'company name': 'Company name',
  name: 'Name',
  post: 'Title',
  country: 'Country',
  province: 'Province',
  city: 'City',
  emailCodeSendTip:
    'We have sent you a verification code to confirm your email, please log in to your mailbox to check the verification code to complete your password setting.',
  'The verification code has been sent': 'The verification code has been sent',
  // 'Please enter your correct email address': 'Please enter your correct email address',
  'Please enter your correct mobile': 'Please enter your correct mobile',
  'The two passwords you entered did not match': 'The two passwords entered did not match',
  'select placeholder': 'Please select',
  'Please upload your avatar': 'Please upload your profile photo',
  'Please enter your name': 'Please enter your name',
  'Please enter your company name': 'Please enter your company name',
  'Please enter your position': 'Please enter your title',
  'The mobile phone number already exists, please enter again':
    'The mobile phone number already exists, please enter again',
  'The mailbox already exists, please enter again': 'The mailbox already exists, please enter again',
  // TODO: chat feature
  'Camera not found, please check your browser settings.':
    'Camera not found, please check your browser settings',

  // exhibits form
  'Add Exhibit': 'Add Product',
  'My Exhibit List': 'My Product List',
  'Upload picture': 'Passport photo',
  'Upload picture2': 'Upload picture',
  'Upload again': 'Upload again',
  'Add picture': 'Add picture',
  'Only support png & jpg, less than 1Mb': 'No less than 1200*560 pixel, png or jpg format only, less than 2M',
  'Only support png & jpg, less than 1Mb 350px': 'No less than 350*350 pixel, png or jpg format only, less than 2M',
  'uploadTips2': 'Only support png & jpg, less than 2M',
  'Uploaded image only support png and jpg': 'For uploading image only support png and jpg!',
  'Uploaded image can not greater than 1Mb': 'For uploading image can not exceed 2M',
  'Upload video': 'Upload video',
  'Add video': 'Add video',
  'Only support mp4, less than 10Mb': 'Less than 100M',
  'Uploaded video only support mp4': 'For uploading video only support mp4',
  'Uploaded video can not greater than 10Mb': 'For uploading video can not exceed 100M',
  'Upload long picture': 'Upload long picture',
  'Add product tags': 'Add product tags',
  'Product tags': 'Product tags',
  'Add form data': 'Add data',
  'Confirm and publish': 'Confirm and publish',
  Yes: 'Yes',
  No: 'No',
  'Please fill product name': 'Please type product name',
  'Please upload at least one picture': 'Please upload at least one picture',
  'Please select product tag': 'Please select product tag',
  'Please upload at least one long picture': 'Please upload at least one long picture',
  'Please select identity': 'Choose Your Role',
  // exhibit detail
  'Exhibitor Name': 'Exhibitor',
  'Exhibit Brand': 'Product Brand',
  'Minimum Order Quantity': 'Minimum Order Quantity',
  'Product BuyPrice': 'Purchase price',
  'Product SalePrice': 'Sale price',
  'Spot Trading': 'Spot Trading',
  'Product Identification': 'Product Identification',
  'Customization Services': 'Customized Services',
  'Visible scope': 'Visible scope',
  'Copy Link': 'Copy Link',
  'Generate Link': 'Generate Link',
  Copied: 'Copied',
  'productSearch': 'Search by exhibit name or article number',
  // company info
  'Upload logo': 'Upload logo',
  'Add company tags': 'Add company tags',
  'Add company description': 'Add company description',
  'comingSoon': 'You are registered. Please visit Beijing International High-tech Exop on October 21-27',
  'setPassWord': "You haven’t set your password yet. Do you want to set it now?",
  'tips':'Warning',
  'ok':'OK',
  'cancel':'Cancel',
  'infoCn': 'Please switch to Chinese to view the information',
  'infoEn': 'Please switch to English to view the information',
  'aboutus': 'About Us',
  'comingSoon2': 'You have not completed the registration, please go to fill in now.',
  'auditTip':'Your registration is under review, please wait for the result patiently. Any questions, please feel free to contact info@jinhanfair.com.',
  'auditTip1':'Your registration is not approved. Please submit qualified information as required again. Any questions, please feel free to contact info@jinhanfair.com.',
  'resiInfo': 'Ok',
  'change': 'Change',
  'productError': 'Failed：product category cannot be more than 3',
  'exportCustomer': 'Export',
  'liveName':'Please enter the name of the live broadcast',
  "liveKeyWorld":"Search by keyword",

  'liveStartTime':"Please select the start time",
  'liveEndTime':"Please select the end time",

  'liveSponsorName':'Please enter exhibitor name',
  'messageMail': 'Notice',
  'Message management': 'Message management',
  'mail': {
    'INVITE': 'Meeting Invitation',
    'CHECKRESULT': 'Review Notifications',
    'SPONSOR': "Organizer's Notifications"
  },
  'goBack': 'Back',
  'smsCodeLogin': 'Log in via SMS',
  'passwordLogin': 'Log in via password',
  'registerTips': 'Please hold down the slider and drag it to the far right to verify',
  'registerSuccessTips': 'Verified successful',
  'slideCode':'Please slide the verification code',
  'Next': 'Next',
  'emailConfirmation': 'Confirm Email',
  // 'emailTitle': 'Please confirm your login information in the email',
  'emailTitle': 'Please confirm your login',
  'emailContent1': "We've sent you a confirmation email. Please check and click the",
  'emailContent2': ' confirmation link ',
  'emailContent3': 'to complete your registration.',
  'emailContent4': 'If you did not receive this message in your inbox, it may have been intercepted by the system, please look it up in the bin. Gmail users should check out the admail.',
  'resendMessage': 'Resend the e-mail',
  'Service Email': 'Email:',
  'infoExistence': 'This user is already exists',
  'codeRrror': 'Verification code is wrong',
  'Create Account': 'Create Account',
  'Confirm Email': 'Confirm Email',
  'Set Password': 'Set Password',
  'Fill in info': 'Fill in info',
  'Questionnaire': 'Questionnaire',
  'Completed': 'Completed',
  'Completed Registration': 'Registration Completed',
  'registerCompletedTips': 'Registration Confirmation',
  'registerSuccessContent': "Thanks for your registration of Beijing International High-tech Exop, Let's look forward for it.",
  'registerCompletedTips1': 'Under Review',
  'registerSuccessContent1': "Thanks for your registration of Beijing International High-tech Exop for Home & Gifts, the online exhibition will be held on 21-27,October. All information of exhibitors and products will be available at that moment.Let's look forward for it.",
  // 'registerSuccessContent1': 'Thanks for your registraiton of Beijing International High-tech Exop for Home & Gifts. Your information is under review, please wait for the result patiently. Any questions, please feel free to contact info@jinhanfair.com.',
  'registerCompletedTips2': 'Not Approved',
  'registerSuccessContent2': 'Sorry that your registration of Beijing International High-tech Exop for Home & Gifts is not approved. Please submit qualified documents as required again. Any questions, please feel free to contact info@jinhanfair.com.',
  
  'goHome': 'Confirm',
  'Messag List': 'Message list',
  'baseInfo': 'Basic information',
  'Head Image1': 'Please upload your ID photo',
  'Head Image2': 'The photo will also be used for the exhibition entry certificate',
  'workPassTips': 'Please upload your personal work permit photo',
  'registrationTips': 'Please upload the photo of the 《registration certificate of your foreign regional representative office》',
  'Please select the visible range': 'Please select the visible range',
  'Please select the visible range2': 'Please select product tag or visible range',
  'Please select the exhibits to be modified': 'Please select the exhibits to be modified',
  'Batch editing': 'Batch editing',
  'Batch deletion': 'Batch deletion',
  'Select the current page': 'Select the current page',
  'No data on the current page': 'No data on the current page',
  'a olute or self-relative': 'a olute or self-relative',
  'exhformTisp': 'Notice: ',
  'exhformTisp1': 'Click rate  can lead to conversion rate',
  'exhformTisp2': 'Good product display can reflect the selling point better and attract buyers to click',
  'exhformTisp3': 'The following four points determine whether the customer clicks and continues browsing',
  'exhformTisp4': '1. Bright and beautiful, attracting clicks',
  'exhformTisp5': '2. Show multiple colors and styles',
  'exhformTisp6': '3. Show advantages or details',
  'exhformTisp7': '4. Explain preferential activities and promote order placement',
  'exhformTisp9': '1. Uploaded here is a picture of a single product, you can upload pictures of different angles and styles of the product.',
  'exhformTisp10': '2. The size is not less than 750*750 pixels, supports png, jpg format, not more than 2Mb, you can upload up to ten product Images.',
  'exhformTisp11': 'To improve click-through rate, main video must go first',
  'exhformTisp12': 'Buyers are more willing to see vivid Videos rather than flat pictures.',
  'exhformTisp13': 'Buyers will see the product video before seeing the product Image.',
  'exhformTisp14': 'The video cover appears in the video location when the video is not playing',
  'exhformTisp15': '1. Video cover should be png, jpg format, no more than 1Mb, you can upload only one cover Image.',
  'exhformTisp16': '2. Video should be mp4, avi, flv format, no more than 100Mb, you can upload a Video.',
  'exhformTisp17': '3. The best display effect can be obtained only when the video cover and the video are square.',
  'exhformTisp18': 'Choose your product labels accurately to help you match quality buyers more accurately.',
  'exhformTisp19': 'The details need to be exciting to increase the conversion rate.',
  'exhformTisp20': 'Upload details of your exhibits, highlight product positioning and selling points, to stand out from the crowd.',
  'exhformTisp21': 'Tell stories, introduce products, and describe scenes with exquisite graphics.',
  'exhformTisp22': '1. Upload the detailed images and texts of the exhibits here. In order to obtain the best display effect and loading speed, the images need to be uploaded in parts.',
  'exhformTisp23': '2. The recommended size of each picture is 1200*600, support png, jpg format, no more than 1Mb',
  'Cancel the full selection': 'Cancel the full selection.',
  'releaseTips':'You can publish supply information in News Feeds, and the customer target that matches your choice will see your release through his/her business network, bringing you business opportunities.',
  'hot exhibits': 'Hot Exhibits',
  'productRangeTip': 'The total number of all visible products can be uploaded up to 10, and the number of other ranges is unlimited',
  'productRangeTip2': ['A total of ', ' sheets, you can also upload ', ' sheets'],
  'contactPerson': 'Your account does not exist, please contact your company administrator to create',
  'noPassword': 'No password is set for this account, please set the password first, and it will automatically jump to the password setting page within 3 seconds',
  'invitationCode': 'Invitation Code',
  'invitationCodeTips1': '1.Exhibitors can send the invitation code to the target audience',
  'invitationCodeTips2': '2.The audience can view live broadcasts and exhibits that are only visible to the customer pool through the invitation Code',
  'invitationCodeTips3': '3.The audience invited by the invitation code will directly join your customer pool',
  'clickCopy': 'Click to copy',
  'actorLoginTips': 'Note: If the account has been created, please click "Forgot Password" to set the password first when logging in',

  'note2': 'Please note:',
  'noteText': ['at most ', ' can be selected'],
  'Please upload a cover image of the video while uploading the video. Otherwise the front-end display will be blank.': 'Please upload a cover image of the video while uploading the video. Otherwise the front-end display will be blank.',
  'Please upload Video.': 'Please upload Video.',
  'Watch the live stream.': 'Watch the live stream.',
  'You need to invite exhibitors, or use the invitation code to watch the live broadcast': 'You need to invite exhibitors, or use the invitation code to watch the live broadcast',
  'To watch the live broadcast, please invite the exhibitor immediately or enter the invitation code to watch.': 'To watch the live broadcast, please invite the exhibitor immediately or enter the invitation code to watch.',
  'Invite now': 'Invite now',
  'Or, enter the invitation code and watch': 'Or, enter the invitation code and watch',
  'Please enter the invitation code': 'Please enter the invitation code',
  'Contact exhibitors via IM to get the invitation code': 'Contact exhibitors via IM to get the invitation code', 
  'determine': 'OK',
  'actorDetailRegister': 'Register now to view more products',
  'actorDetailInite': 'Invite exhibitors to view more products',
  'actorDetailInite2': 'or, enter the invitation code and view directly',
  'Invitation code error': 'Invitation code error',
  'Password error': 'Password error',
  'Private live broadcasting': 'Private live broadcasting',
  'inviteTips': "Successfully invited exhibitors can join the exhibitor's client pool to see more exhibitors and live streams authorized by the exhibitor.",
  'For details, please invite exhibitors': 'For details, please invite exhibitors',
  'Unregistered users can only see limited products. Please register to view more.': 'Unregistered users can only see limited products. Please register to view more.',
  'inviteTips2': 'You may see more products in company page when you are approved by the exhibitor. Please click “invite”.',
  'onLine': '本机网络已连接，请刷新您的页面',
  'offLine': '本机网络掉线, 请检查您的网络',
  'error': 'Error',
  'The name you entered is inconsistent with the ID number.': 'The name you entered is inconsistent with the ID number.',
  'Token failed to get. Please get again': 'Token failed to get. Please get again',

  'badgeCard': 'Card',

  'VR Exhibition': 'VR',
  'exhibitorManual': 'Exhibitor Manual',
  'reportPageTip': ['All browsing data statistics include tourist data.', 'Tourist data removed from exported data.'],
  'loadingText': 'Data Loading...',
  'screenText': 'filter',

  'Latest Products': 'Latest Products',
  'Latest Products Tips1': '1. The cover image of each product is uploaded here',
  'Latest Products Tips2': '2. Size not less than 175 * 175 pixels, support PNG, JPG format, no more than 2MB, you can upload up to six product drawings',
  'Latest Products Tips3': '3. Upload all six pictures to achieve the best display effect',
  'Latest Products Tips4': 'Only Excel files can be uploaded here',
  'Upload file': 'Upload file',
  'Please select at least one exhibit': 'Please select at least one exhibit',
  'Please enter the information of the invitee': 'Please enter the information of the invitee',
  'downloadTemplate': 'Download Template',
  'sendOut': 'Send Out',
  'Add': 'Add',
  'You can choose up to six exhibits': 'You can choose up to six exhibits',

  'Modify file name': 'Modify file name',
  'This will permanently delete the file. Continue?': 'This will permanently delete the file. Continue?',
  'Delete completed': 'Delete completed',
  'Please enter a file name': 'Please enter a file name',
  'filename is incorrect': 'filename is incorrect',
  'Revise Success': 'Revise Success',
  'Upload information': 'Upload information',
  'Exhibitor information': 'Exhibitor information',
  'No valid data': 'No valid data',
  'overseasRegistration': 'Overseas Registration',
  'renzheng': 'Certified user',
  'renzhengIcon': 'Certified',
  'VIP': 'VIP user',
  'Upload exhibits': 'Upload exhibits',
  'APPROVE': 'APPROVE',
  'PENDING': 'PENDING',
  'visitor': 'visitor',
  'exhibitMaxSort': 'Current maximum sort value ',

  'inviteSendTips': "If you need to upload the user's email in batch, please download the template, fill in according to the template and upload the file",
  'Download Confirmation': 'Download Confirmation',
  'Please wait': 'Please wait...',
  'hostpotTips': 'Digital Showcase is a better way to help you display your products, highlight its characteristics in a special scene. ',

  'mentInvitation': 'Invitation',

  'exhibits-sort-input1': "1. The order of exhibits will be in positive order according to the serial number you entered, which will be reflected in the exhibits list of your current exhibits list page and the exhibitor details page;",
  'exhibits-sort-input2': "2. When the sequence number of the existing exhibits is greater than or equal to the number filled in, it will be + 1. For example, if the sequence number of the existing exhibits is 1-10 and 2 is filled in, then the previous 2 becomes 3, 3 becomes 4, and so on;",
  'exhibits-sort-input3': "3. If no serial number is set for your uploaded exhibits, the system will perform flashback according to the time of your uploaded exhibits by default, and it will be behind the ones with serial number set (in order to better manage your exhibits, it is recommended that you upload serial number)",
  'bannerVideoTip': 'Wait for 5 seconds to the next page.',

  'bizhubTips1': "You haven't posted any sourcing requirement yet. Please click here to ",
  'bizhubTips2': 'post now',
  'Only non Chinese characters can be entered': 'Only non Chinese characters can be entered',
  'only number': 'Can input numbers',

  'Online Sourcing Meeting': 'Online Sourcing Meeting',
  'Batch upload of exhibits': 'Batch upload of exhibits',
  'Download template': 'Download template',
  'Batch upload tips': 'The batch uploaded exhibits will be automatically synchronized to the exhibits management - exhibits list by improving the exhibits information',
  'Download enterprise QR code': 'Download QR code',
  'Please use gift show app to scan code and pay attention to exhibitors': 'Please use gift show app to scan code and pay attention to exhibitors',
  'Download': 'Download',
  'Picture clipping': 'Picture clipping',
  'clippingTips': 'Slide the mouse wheel to enlarge or reduce the picture and cut the picture to achieve the best display effect.',
  'On-site Registration Hours': 'On-site Registration Hours',
  'Fair Opening Time': 'Fair Opening Time',
  'copy': 'copy',
  'Are you sure copy this item?': 'Are you sure copy this item?',
  'Can be downloaded': 'Can be downloaded',
  'prtentialOrderTips': "The intention order can be exported, which is convenient for you to carry out through the audience's mobile phone number / email / phone",

  'procurementDocking': 'Manage Online Sourcing Meeting',
  'ID Card': 'ID Card',
  'Wrong ID number': 'ID Card Error',
  'Mobile area code cannot be empty': 'Mobile area code cannot be empty',
  'Company telephone area code cannot be empty': 'Company telephone area code cannot be empty',
  'Headquarters telephone area code cannot be empty': 'Headquarters telephone area code cannot be empty',
  'Format error': 'Format error',
  'The password length is 6-16 bits': 'The password length is 6-16 bits',

  'RegistrationOfDockingMeeting': 'Sign up Online Sourcing Meeting',
  'ApplicationDockingMeeting': 'Post Sourcing Requirement',
  'Batch upload': 'Batch upload',

  "INVITE": "Invite customers",
  "CARD": "Business card exchange",
  "INVITATION":"Invitation",
  "INVITE_CODE": "Invitation code",
  "DISTRIBUTION":"Administrator assignment",
  "NEWCUSTOMER": "Create customer",
  "INVITE_CODE_LIVE": "Live invitation code",
  'ALL': 'All',

  'Filter by source': 'Filter by source',
  '绑定': 'Binding',
  '解绑': 'Unbound',
  '暂未绑定邮箱': 'Mailbox is not bound yet',
  '暂未绑定手机号': 'Mobile phone number is not bound yet',
  '更换': 'Replace',
  '为了保护账户安全，请验证身份': 'To protect your account, please use {0} to authenticate',
  '至少绑定一个账号': 'Bind at least one account',
  '请输入账号': 'Please enter the account number',
  '手机号格式错误': 'Mobile phone number format error',
  '邮箱格式错误': 'Email format error',
  '请输入正确的验证码': 'Please enter the correct verification code',
  '尊敬的': 'Dear',
  '尊敬的顾客': 'Dear customer',
  '邀请函提示内容': 'We will be exhibiting in the Beijing International High-tech Exop,sincerely invite you to attend this fabulous event. We are expecting to meet you there!',
  '谨上': 'Yours sincerely,',
  '公司名称': 'Company Name',
  '提示': 'Note:',
  '提示信息': 'Click the photo or company name, complete the registration, you will be added to the customer pool of this exhibitor automatically.',
  '查看更多': 'View More',
  '晋江热门产业': 'Hot Industries in Jinjiang',
  '港澳台和海外侨商': 'Hong Kong, Macao and Taiwan, and Overseas Chinese Businessmen',
  '在线会议': 'Online Meeting',

  "该手机号已注册": "The phone number Already registered, please log in",
  "该邮箱已注册": "The mailbox has been registered, please log in",
  "拉取会话失败": "Pull session failed",
  
  "发送": "Send",
  "发表情": "Send Emoticon",
  "发图片": "Send pictures",
  "发视频": "Send video",
  "发文件": "Sending documents",
  "没有更多了": "There's no more",
  "回到最新位置": "Return to the latest position",
  "系统通知": "System notifications",
  "不能发送空消息哦！": "Cannot send empty messages!",
  "由于多实例登录": "Due to multi instance login",
  "由于多设备登录": "Due to multiple device logins",
  "由于 userSig 过期": "Due to userSig expiration",
  "已接入网络": "Connected to the network",
  "当前网络不稳定": "The current network is unstable",
  "当前网络不可用": "The current network is not available",
  "删除会话": "Delete Session",
  "你撤回了一条消息": "You withdrew a message",
  "对方撤回了一条消息": "The other party withdrew a message",
  "撤回了一条消息": "Recalled a message",
  "会话": "Session",
  "删除成功": "Successfully deleted",
  "删除失败": "Delete failed",
  "刷新列表": "Refresh List",
  "刷新成功": "Refresh successful",
  "撤回": "withdraw",
  "重新编辑": "Re edit",
  "已读": "READ",
  "未读": "UNREAD",
  "暂未支持的消息类型": "Message types not currently supported",

  "您可以自行解析自定义消息": "You can parse custom messages yourself",
  "[自定义消息]": "[custom message]",
  "单击下载": "Click to download",
  "视频出错，错误原因：": "Video error, error reason:",

  "游客": "Visitors",
  "获取游客信息失败": "Failed to obtain tourist information!",
  "获取在线客服信息失败": "Failed to obtain online customer service information!",
  "已经没有更多的历史消息了哦": "There's no more historical news left",
  'purchaseMeeting': 'Purchase Meeting',
  "meetingList": "Meeting",


  "零成本": "zero-cost",
  "定制": "Customized",
  "有效": "Effective",
  "注册观众才能提交": "Only registered visitors can submit",
  "对接会描述": "Beijing International High-tech Exop Source Matching is a customized service that connects buyers with pre-matched suppliers. It is a targeted virtual business meeting, email or phone-call that provides an opportunity for both sides to communicate directly.",
  "对接会提示1": "Easy scheduling by Beijing International High-tech Exop team",
  "对接会提示2": "Quick response from decision makers",
  "对接会提示3": "Showroom tour by selected suppliers",
  "对接会会议按钮": "Start the best virtual meeting today",
  "未注册用户仅看到展商全部公开的产品": "Register now to view more {num} + exhibits.",
  "未注册用户仅看到展商全部公开的产品，要查看更多产品，需先完成注册": "Unregistered users can only see all the exhibitors' public products. To view more products, they need to complete registration first",
  "点击查看更多": "Click to see more",
  "请先登录展商账号": "Please log in to the exhibitor account first",
  "请进行校验": "Please check",
  "登录观众后才能发起需求": "Registration can only be initiated after logging in to the audience",
  "请登出，使用游客身份访问": "Please log out and visit as a tourist",
  "请使用观众身份访问": "Please login your visitor account to sign up.",
  "请使用展商身份访问": "Please visit as an exhibitor",
  "图片为": "The size of {type} file with {resolving} picture cannot exceed {size} MB, and {num} pictures can be uploaded at most",
  "报名状态": "Registration status",
  "没有记录": "No record",
  "实名制认证失败": "Certificate failure",
  "非权益展商": "Only the upgrade package or Quanzhou exhibitors can sign up",
  "公司性质": "Nature of company",
  // "公司名称": "Company name",
  "采购者信息": "Purchaser information",
  "联系电话": "Contact number",
  "产品详情": "Product details",
  "产品标签": "Product labeling",
  "产品图片": "Product picture",
  "证书": "Certificate",
  "数量": "Quantity",
  "供应商需求": "Supplier requirements",
  "供应商性质": "Nature of supplier",
  "公司规模": "Company size",
  "区域": "Region",
  "其他": "Other",
  "预约时间": "Time of appointment",
  "选择日期": "Select date",
  "更多": "More",
  "第场": "Scene {num}",
  "场次": "Scene",
  "立即报名": "Sign up now",
  "已经报名": "Already signed up",
  "报名结束": "End of registration",
  "全国糖酒商品交易会线上采购对接会报名": "Beijing International High-tech Exop Source Matching registration now",
  "请有意向参加线上采购对接会的参展商填写以下信息": "Please fill in the information for exhibitors",
  "姓名": "Name",
  "手机": "Mobile",
  "网址": "Website",
  "描述": "Describe",
  "选择展品": "Select exhibits",
  "热词搜索": "Hot words",
  "线下展商": "Offline Exhibitors",
  "报名成功": "Registration success",
  "采购对接会日程安排": "Schedule of Source Matching",
  "序号": "SN",
  "对接会名称": "Buyer Info.",
  "首页对接会描述": "Description",
  "首页对接会时间": "Meeting time",
  "时间": "Time",
  "地点": "Place",
  "开始时间": "Start Time",
  "结束时间": "End Time",
  "至": "-",
  "状态": "Status",
  "对接会状态": "Docking status",
  "已报名": "Registered",
  "未报名": "Not registered",
  "已结束": "Has ended",
  "未结束": "Not finished",
  "展品": "Exhibits",
  "搜索": "Search",
  "开展展会名称": "25th China International Agrochemical & Crop Protection Exhibition",
  "开展时间英文": "17-19 March, 2025",
  "开展地点英文": "National Exhibition and Convention Center (Shanghai)",
  "News": "News",
  "请选择": "Please select",
  "展商": "Exhibitors",
  "展品": "Exhibits",
  "展位号": "Booth number",
  "请输入关键词搜索展商/展品": "Please enter keywords",
  "筛 选": "Filter",
  "重 置": "Reset",
  "boothGuide": "Booth Guide",
  "展商列表": "Exhibitor List",
  "展商详情": "Exhibitor Details",
  "用户登录": "User Login",
  "我的收藏": "My Favorites",
  "输入供应商，产品或展位名称搜索": "Search by supplier, product or booth No.",
  "返回首页": "Return to Home",
  "查看详情": "View Details",
  "产品图片": "Exhibited Products",
  "赞助企业": "Sponsoring enterprises",
  "合作媒体": "Associated Media",
  "退出": "Log Out",
  "我的收藏": "My Favorites",
  "预定展位请联系": "Please contact for booth reservation",
  "展商名录": "Company List",
  "展商分类": "Exhibition Category",
  "返回": "Back",
  "请选择分题展":"Please choose a sub topic exhibition",
  "请选择展馆": "Select the hall",
  "请选择国别": "Please select a country",
  "重置": "Reset",
  "全部": "ALL",
}
